import { render } from "./Step5Account.vue?vue&type=template&id=c67c1d3e&scoped=true"
const script = {}

import "./Step5Account.vue?vue&type=style&index=0&id=c67c1d3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c67c1d3e"]])

export default __exports__